import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { Button } from "@/components/ui/button";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  useEffect(() => { api.get("/public/deals").then((r) => setDeals(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-10">
        <span className="overline text-primary">Limited Time</span>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight lg:text-4xl">Deals & Offers</h1>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {deals.length === 0 && <p className="text-muted-foreground">No active deals right now.</p>}
          {deals.map((d) => (
            <div key={d.id} className="relative overflow-hidden rounded-2xl border border-border" data-testid={`deal-${d.id}`}>
              <img src={d.image} alt={d.title} className="h-64 w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/20" />
              <div className="absolute inset-0 flex flex-col justify-center p-8 text-white">
                {d.discount_percent > 0 && <span className="mb-2 w-fit rounded-full bg-primary px-3 py-1 text-xs font-bold">{d.discount_percent}% OFF</span>}
                <h3 className="font-display text-2xl font-bold">{d.title}</h3>
                <p className="mt-1 text-white/80">{d.description}</p>
                <Button asChild size="sm" className="mt-4 w-fit rounded-full"><Link to={d.button_link || "/products"}>{d.button_text || "Grab Deal"}</Link></Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
